/**
 * @generated SignedSource<<111748312b6421632dd7bbd8d411e593>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRequest = {
  id: string;
};
export type UsersTabArchiveMutation$variables = {
  input: DeleteRequest;
};
export type UsersTabArchiveMutation$data = {
  readonly archiveUser: {
    readonly id: string;
  };
};
export type UsersTabArchiveMutation = {
  response: UsersTabArchiveMutation$data;
  variables: UsersTabArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUser",
    "kind": "LinkedField",
    "name": "archiveUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersTabArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UsersTabArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dbdd4fe45fe90cce29e42225f4a9edff",
    "id": null,
    "metadata": {},
    "name": "UsersTabArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation UsersTabArchiveMutation(\n  $input: DeleteRequest!\n) {\n  archiveUser(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "943bc65e197d69cbb3ee8e9731c6190c";

export default node;
